<docs>
  # UiKit - Button - Primary
  > *generic way to create any Primary cta*
</docs>
  
<script lang="ts">
import IconSVG from "assets/svg/select.svg?raw";
import { defineComponent, PropType, toRefs } from 'vue';
import UiButtonSimple from './index.vue';

const UiThemedButtonPrimary = defineComponent({
  name: "UiButtonThemedPrimary",
  components:{UiButtonSimple},
  extends:UiButtonSimple,
  props:{
    theme: {
      type: String as PropType<ButtonTheme>,
      default: 'primary'
    },
    direction: {
      type:  String as PropType<ButtonDirection>,
      default: 'left'
    },
    icon: {
      type: String,
      default: IconSVG
    }
  },
  setup(props) {
    return {
      ...toRefs(props),
      IconSVG,
    }
  }
});
export default UiThemedButtonPrimary
</script>
  
<template>
  <ui-button-simple class="UiButtonThemedPrimary"
                    :data-theme="theme"
                    :data-variant="variant"
                    :data-dark="dark"
                    :data-selected="selected"
                    :data-highlight="true"
                    v-bind="$props"
  >
    <slot>
      <span v-if="$props.label"
            class="label"
            :data-label="$props.label"
      >{{ $props.label }}</span>
    </slot>
  </ui-button-simple>
</template>
  
<style lang="stylus" scoped>
  [data-theme="primary"]
    position relative
    user-select none
    display inline-block
    f-style(button)
    rp(padding-top, 10px)
    rp(padding-bottom, 10px)
    rp(padding-left, 15px)
    rp(padding-right, 15px)
    text-transform uppercase
    rp(border-radius, 5px)
    trans(background-color, $duration:.5s)
    trans(color, $duration:.5s)
    trans(border-color, $duration:.5s)
    &[data-dark="true"]
      addVariantHover(true)
    &[data-dark="false"]
      addVariantHover(false)

    :deep()
      .inner
        .icon
          transform none
          rp(width, 10px)
          rp(height, 10px)
          margin-right 10px
</style>
  